package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_12_13_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("nearly")
        }
        org.jetbrains.compose.web.dom.Text(" captured Ludwig Voss and are fighting his goons. Caper grapples Voss. A goon tries to command Tuesday but is Counterspelled. A goon once again uses Dreadful Aspect, attempting to frighten the heroes, but with Caper leading the way, even the smallest of the heroes isn’t afraid of the hideously ugly goon. Dirk kills the remaining goons with Cone of Cold.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes turn to Voss.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Well, you have pissed off my benefactor, Lord Pent…")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Voss grips a silver amulet hanging around his neck and mutters an incantation. Caper Counterspells him. The heroes surround Voss; Caper holds him, while the other heroes beat him within an inch of his life. When Voss passes out, the heroes tie him up. The heroes search Voss, finding the following items which they later identify:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("dagger +3")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("dagger or returning")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("leather armor - studded +2")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("necklace - alteration - ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/4570-amulet-of-the-planes") {
                org.jetbrains.compose.web.dom.Text("Amulet of the Planes")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("ring - protection +1")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("shortbow +2")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis and Bigglesworth drag the bodies of the goons out-of-sight. Korvis suspects that the goons are oathbreaker paladins.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When Voss regains consciousness, the heroes interrogate him. He claims that:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("His benefactor, Lord Pent resurrected him.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Lord Pent is normally home in Pentish but sometimes travels to Dorvid, the Dorvidian capital city.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The Amulet of the Planes is his escape lifeline to the Feywild or Shadowfell.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He (Lord Pent) is searching for Shard of Concar pieces.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("He didn’t directly hire the goons. Yes, they are oathbreakers and seem “a bit off.”")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn sending spells to Prudence of the Barrowmen, asking if the heroes could hand over this killer to their care. Prudence provides directions to a nearby safe house.  Tuesday is tired of listening to Voss and polymorphs him into a quokka. The heroes deliver “Voss the Quokka” to the safe house.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes hastily wind walk to Lord Fox’s estate, as their battle with Voss put them behind schedule. They talk to Arthur, the guard, and enter through a different entrance. As they enter, they hear a quartet of professional musicians playing music. Fox is wearing armor with a two-handed sword on his back. Guards are present as well. Fox says, “I can’t wait to show you my magical mysteries.”")
    }
}
